import { createCoreMethod } from '../../utils/createCoreMethod';
import { shallowFind } from '../../utils/shallowFind';

export const getParentNodeType = createCoreMethod(
  'getParentNodeType',
  async (startingPointId: string): Promise<BaseNode['type'] | null> => {
    const startingNode = shallowFind(startingPointId);

    if (!startingNode) return null;

    if (!startingNode.parent) return null;

    return startingNode.parent.type;
  }
);
